// extracted by mini-css-extract-plugin
module.exports = {"container":"CommonPage_container__bVQJ4","scrollable":"CommonPage_scrollable__RwXX6","shimmer":"CommonPage_shimmer__56pVl"};